<template>
  <el-dialog
    :title="$t('productGroupManage.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align:center;margin-bottom:20px">
      <p>{{ $t('productGroupManage.confirmDeleteProduct') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('productGroupManage.cancel') }}
      </el-button>
      <el-button type="primary" @click="deleteProductGroup">
        {{ $t('productGroupManage.confirmDelete') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteProductGroup } from '@/api/group/productGroupApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteProductGroup',
  data() {
    return {
      dialogVisible: false,
      deleteProductGroupInfo: {
        groupId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteProductGroupInfo.groupId = row.groupId
    },
    handleClose() {
      this.deleteProductGroupInfo = {
        groupId: ''
      }
    },
    async deleteProductGroup() {
      try {
        this.deleteProductGroupInfo.shopId = getShopId()
        await deleteProductGroup(this.deleteProductGroupInfo)
        this.$message.success(this.$t('common.submitSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    }
  }
}
</script>